/**
 * @generated SignedSource<<8d40e36eef13068715a66ec3592cdb50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AuthReissueMutation$variables = {
  email: string;
};
export type AuthReissueMutation$data = {
  readonly reissuePassword: {
    readonly email: string;
  };
};
export type AuthReissueMutation = {
  response: AuthReissueMutation$data;
  variables: AuthReissueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthReissueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReissuePasswordMutationPayload",
        "kind": "LinkedField",
        "name": "reissuePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthReissueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReissuePasswordMutationPayload",
        "kind": "LinkedField",
        "name": "reissuePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37e6f753676583a6afd9e3d92cdcceb5",
    "id": null,
    "metadata": {},
    "name": "AuthReissueMutation",
    "operationKind": "mutation",
    "text": "mutation AuthReissueMutation(\n  $email: String!\n) {\n  reissuePassword(input: {email: $email}) {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc1bd39b27a0d5c7ba6505e747731e57";

export default node;
